import { getDomain } from 'lib/utils/index';
import getConfig from 'modules/config';
import { isProduction } from '../labrador/utils';
import getUrl from './getUrl';

export const getUserAuthUrl = () => {
  return isProduction ? 'https://login.allermedia.se' : 'https://login-stage.allermedia.se';
};

const getAuthUrlFactory = (path?: string) => (params?: Record<string, string>) => {
  const url = getUrl(path ?? '', getUserAuthUrl());
  const searchParams = new URLSearchParams(params ?? { return: getDomain(false) });

  if (!url) {
    throw Error('Unable to get user auth url');
  }

  url.search = searchParams.toString();

  return url.href;
};

export const getUserLogInUrl = getAuthUrlFactory();

export const getUserSignUpUrl = getAuthUrlFactory('/nytt-konto');

export const getUserPageUrl = getAuthUrlFactory('/mina-sidor');

export const getUserLogOutUrl = getAuthUrlFactory(`/logout/${getConfig('login.brandName') ?? ''}`);
